import {trackLogout} from '@aboutyou/legacy-tracking-sdk';
import {useTracking} from '../utils/utils';

export const useTrackLogout = () => {
  const {TrackingClient, pageContextCallback, scheduleCustomerDataEvent} =
    useTracking();
  return (status: 'successful' | 'error') => {
    scheduleCustomerDataEvent();
    TrackingClient.track(trackLogout({status, page: pageContextCallback()}));
  };
};
